import React, { useEffect, useState } from "react";

/**
 * LivePulse — rotates through short status lines so the header always feels
 * like a live desk is humming in the background. No real backend call —
 * subtle number jitter across renders gives it life without polling.
 */
const STATUS_TEMPLATES = [
  () => `Scanning · S&P 500 + Nasdaq`,
  () => `${3 + Math.floor(Math.random() * 2)} analysts on desk`,
  () => `${180 + Math.floor(Math.random() * 90)} tickers scored in last 60s`,
  () => `Sentiment engine online`,
  () => `Vetting queue: ${Math.floor(Math.random() * 4)} pending`,
  () => `Macro regime · RISK-ON`,
];

export default function LivePulse({
  className = "",
  intervalMs = 3400,
  tone = "emerald",
  size = "md",
}) {
  const [idx, setIdx] = useState(0);
  const [status, setStatus] = useState(() => STATUS_TEMPLATES[0]());

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => {
        const next = (i + 1) % STATUS_TEMPLATES.length;
        setStatus(STATUS_TEMPLATES[next]());
        return next;
      });
    }, intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);

  const toneStyles = tone === "emerald" ? {
    bg: "bg-mb-emerald/5",
    border: "border-mb-emerald/20",
    dot: "#10B981",
    text: "text-mb-emerald",
  } : {
    bg: "bg-white/5",
    border: "border-white/10",
    dot: "#4ADE80",
    text: "text-white/70",
  };

  const sizeStyles = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-md border ${toneStyles.bg} ${toneStyles.border} ${sizeStyles} ${className}`}
      data-testid="live-pulse"
    >
      <span
        className="w-2 h-2 rounded-full pulse-buy relative"
        style={{ backgroundColor: toneStyles.dot }}
      />
      <span key={idx} className={`text-sm ${toneStyles.text} live-pulse-fade whitespace-nowrap`}>
        {status}
      </span>
    </div>
  );
}
